import React, { ReactNode } from 'react';
import {CloseButton, Content, Header, HeaderSection, Overlay, Sheet} from "./styles";

interface BottomSideSheetProps {
	isOpen: boolean;
	onClose: () => void;
	header?: ReactNode;
	children: ReactNode;
}

export const EventBottomSideSheet = ({
										 isOpen,
										 onClose,
										 header,
										 children
								}: BottomSideSheetProps) => {
	if (!isOpen) return null;

	return (
		<Overlay onClick={onClose}>
			<Sheet onClick={e => e.stopPropagation()}>
				<Header>
					{header && (<HeaderSection>{header}</HeaderSection>)}
					<CloseButton onClick={onClose}>✕</CloseButton>
				</Header>

				<Content>
					{children}
				</Content>
			</Sheet>
		</Overlay>
	);
};

export default EventBottomSideSheet
